import AddIcon from '@eduzz/houston-icons/Add';
import Button from '@eduzz/houston-ui/Button';
import Select from '@eduzz/houston-ui/Forms/Select';
import List from '@eduzz/houston-ui/List';
import Table from '@eduzz/houston-ui/Table';
import { Grid } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import type { StyledComponentProps } from '@material-ui/core/styles';
import PermissionHide from 'components/PermissionHide';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { listActionsConnect, loadConnect, loadAction } from 'store/Orbita/Connect/actions';
import TopPage from 'v2/components/Shared/TopPage';
import Truncate from 'v2/components/Shared/TruncateText';

import EditAction from '../components/EditAction';
import NewAction from '../components/NewAction';
import styles from '../styles/';

import type { DispatchProp } from 'react-redux';
import type { RouteComponentProps } from 'react-router-dom';

interface IProps extends DispatchProp<any>, RouteComponentProps<any>, StyledComponentProps {
  actions: any;
  currentConnect: any;
  connect: any;
  currentAction: any;
  action: any;
  triggers: any;
  options: any;
}

interface IStates {
  isFetching: boolean;
  searchValue: string;
  openForm: boolean;
  editing: boolean;
  action: any;
  filterAction: string;
  filterTrigger: string;
}

class Actions extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isFetching: true,
      searchValue: '',
      openForm: false,
      editing: false,
      action: false,
      filterAction: '',
      filterTrigger: '',
    };
  }

  componentDidMount() {
    const { connectId } = this.props.match.params;
    if (connectId) {
      (async () => {
        try {
          await this.props.dispatch(loadConnect(connectId));
          let { connect } = this.props;
          await this.props.dispatch({ type: 'CHANGE_CURRENT_CONNECT', connect });
          this.callDataInitial();
        } catch (error) {
          toast.error(error);
          this.props.history.push('/producer/connect/myconnects/');
        }
      })();
    } else {
      this.props.history.push('/producer/connect/myconnects/');
    }
  }

  handleCloseForm = () => {
    this.setState({ openForm: false, editing: false });
  };

  handleOpenForm = (editing: boolean) => {
    this.setState({ openForm: true, editing });
  };

  callDataInitial = () => {
    this.callMoreData();
  };

  handleClickDelete = async () => {
    //const { actionsIdSelected } = this.state;
    //await this.props.dispatch(deleteWhitelist(actionsIdSelected));
    toast.success('Cliente removido com sucesso!');
    this.callDataInitial();
  };

  openModal = () => {
    this.props.dispatch({ type: 'OPEN_MODAL_NEW_ACTION' });
  };

  openModalEdit = (action: any) => {
    (async () => {
      const { currentConnect } = this.props;
      await this.props.dispatch(loadAction(currentConnect.id, action.id));
      await this.props.dispatch({ type: 'CHANGE_CURRENT_ACTION', action });
      this.props.dispatch({ type: 'OPEN_MODAL_EDIT_ACTION' });
    })();
  };

  onSave = () => {
    this.callDataInitial();
  };

  callMoreData = async () => {
    this.setState({ isFetching: true, openForm: false, editing: false });
    const { connectId } = this.props.match.params;
    await this.props.dispatch(listActionsConnect(connectId));
    this.setState({ isFetching: false });
  };

  render() {
    const classes = this.props.classes;
    const connect = this.props.currentConnect;
    const isLoading = this.state.isFetching;
    const triggers = this.props.triggers;
    const options = this.props.options;
    const filterAction = this.state.filterAction;
    const filterTrigger = this.state.filterTrigger;
    const actions = this.props.actions;

    const listActions = Array.isArray(actions) ? actions : [];

    const filteredOptions = listActions.filter((la) => {
      if (filterAction && filterAction !== '' && la.option_id != filterAction) return false;
      if (filterTrigger && filterTrigger !== '' && la.trigger_id != filterTrigger) return false;
      return true;
    });
    return (
      <>
        <Grid container spacing={2} style={{ marginBottom: 16 }}>
          <Grid item xs={12}>
            <Breadcrumbs aria-label='breadcrumb'>
              <Link to='/producer/connect/myconnects'>Connect</Link>
              <p>{connect?.name}</p>
              <p>Lista de ações</p>
            </Breadcrumbs>
          </Grid>
        </Grid>
        <TopPage
          title='Lista de ações'
          action={
            <PermissionHide action={'myeduzz:connect:criar'}>
              <Button startIcon={<AddIcon />} variant='contained' onClick={this.openModal}>
                Nova ação
              </Button>
            </PermissionHide>
          }
        />
        <Grid container spacing={2} alignItems='flex-end'>
          <Grid item xs={12} md={6}>
            <List.Item>
              <List.Left>
                <div className={classes.imageTable} style={{ backgroundImage: `url(${connect?.image})` }}></div>
              </List.Left>
              <List.Text
                title={connect?.name}
                description={
                  <>
                    <p>{connect?.description}</p>
                    <p>
                      <strong>{connect?.parameters[0]?.label}</strong>
                    </p>
                    <Truncate count={50} final='...'>
                      {connect?.parameters[0]?.value}
                    </Truncate>
                  </>
                }
              />
            </List.Item>
          </Grid>

          <Grid item xs={12} md={3}>
            <Select label='Gatilho' value={this.state.filterTrigger} onChange={(v) => this.setState({ filterTrigger: v })}>
              <Select.Option>Todos</Select.Option>
              {triggers &&
                Array.isArray(triggers) &&
                triggers.map((option: any) => (
                  <Select.Option value={option.id} key={option.id}>
                    {option.name}
                  </Select.Option>
                ))}
            </Select>
          </Grid>

          <Grid item xs={12} md={3}>
            <Select label='Ação' value={this.state.filterAction} onChange={(v) => this.setState({ filterAction: v })}>
              <Select.Option>Todas</Select.Option>
              {options &&
                Array.isArray(options) &&
                options.map((option: any) => (
                  <Select.Option value={option.id} key={option.id}>
                    {option.title}
                  </Select.Option>
                ))}
            </Select>
          </Grid>

          <Grid item xs={12}>
            <Table loading={isLoading} total={filteredOptions?.length} emptyText='Nenhuma ação encontrada'>
              <Table.Header>
                <Table.Column>Status</Table.Column>
                <Table.Column>Descrição</Table.Column>
                <Table.Column>Produto</Table.Column>
                <Table.Column>Gatilho</Table.Column>
                <Table.Column>Ação</Table.Column>
              </Table.Header>
              <Table.Body>
                {filteredOptions.map((action: any, index: number) => (
                  <Table.Row data={action} index={index} key={`connect-${action.id}`}>
                    <Table.Cell align='left'>
                      <div>{action.active ? <div style={{ color: '#009358' }}>Ativo</div> : <div style={{ color: '#dc3f53' }}>Inativo</div>}</div>
                    </Table.Cell>
                    <Table.Cell>{action.description}</Table.Cell>
                    <Table.Cell>
                      <strong>{action.product_id}</strong>
                      <Truncate final='...' count={50}>
                        {action.product_title}
                      </Truncate>
                    </Table.Cell>
                    <Table.Cell>{action.trigger}</Table.Cell>
                    <Table.Cell>{action.action}</Table.Cell>
                    <PermissionHide action={'myeduzz:connect:editar'}>
                      <Table.Action onClick={() => this.openModalEdit(action)}>Editar</Table.Action>
                    </PermissionHide>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </Grid>
        </Grid>
        <NewAction currentAction={this.state.action} onSave={this.onSave} />
        <EditAction onSave={this.onSave} />
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    actions: state.orbita.Connect.listActionsConnect,
    currentConnect: state.components.Connect.currentConnect,
    connect: state.orbita.Connect.loadConnect,
    currentAction: state.components.Connect.currentAction,
    action: state.orbita.Connect.loadAction,
    triggers: state.orbita.Connect.listTriggers,
    options: state.orbita.Connect.listConnectOptions,
  };
}

export default withRouter(connect(mapStateToProps)(styles(Actions)));
